import type { Asset } from "@/types/asset";
import type { SceneObject } from "@/types/scene";

export function createUniqueObjectId(asset: Asset, objects: SceneObject[]): string {
  const prefix = asset.id.replace(/\d+$/, "");
  const used = new Set(objects.map((object) => object.id));
  let index = 1;
  let candidate = `${prefix}_${String(index).padStart(3, "0")}`;
  while (used.has(candidate)) {
    index += 1;
    candidate = `${prefix}_${String(index).padStart(3, "0")}`;
  }
  return candidate;
}
